import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountSettingsDomainsModel } from 'src/app/models/api/governance/account-settings.model';
import { HttpService } from '../../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class AccountSettingsHttpService {
  /**
   * The account settings base url
   * @private
   * @readonly
   */
  private readonly _accountSettingsBaseUrl: string = 'account-settings/';

  constructor(private readonly _httpService: HttpService) {}

  /**
   * @public Get Domains
   * @returns an Observable{PolicyModel} with the policies returned from server
   */
  public getDomains(): Observable<AccountSettingsDomainsModel> {
    const url = `${this._accountSettingsBaseUrl}governance/domains`;
    return this._httpService.get<AccountSettingsDomainsModel>(url);
  }

  /**
   * @public Add domains
   */
  public addDomains(input: string[]): Observable<string> {
    const url = `${this._accountSettingsBaseUrl}governance/add-domains`;
    return this._httpService.put<string, string[]>(url, input);
  }

  /**
   * @public Delete domains
   */
  public deleteDomains(input: string[]): Observable<string> {
    const url = `${this._accountSettingsBaseUrl}governance/delete-domains`;
    return this._httpService.put<string, string[]>(url, input);
  }
}
